<template>
  <div class="gyl">
    <div class="title">
      <div class="titleT">供应链</div>
      <div class="titleA"><a href="gyl.html">立即体验<span class="iconfont icon-shuangjiantou"></span></a></div>
    </div>
    <div class="gylOne">
      <div class="left">
        <div class="Otitle">平台直营供应商</div>
        <img src="~@/assets/img/index/gyl1.png">
      </div>
      <div class="jia">+</div>
      <div class="right">
        <div class="Otitle">品牌商</div>
        <img src="~@/assets/img/index/gyl2.png">
      </div>
    </div>
    <ul class="gylTwo">
      <li v-for="(i,index) in list" :key="index">
        <img :src="i.img">
        <div class="info">
          <div class="name">{{i.name}}</div>
          <div class="desc">{{i.desc}}</div>
        </div>
      </li>
    </ul>
    <div class="gylThree">
      <div class="title">
        <div class="titleT">合作方式</div>
        <div class="titleA"><a href="gylshopping.html">立即体验<span class="iconfont icon-shuangjiantou"></span></a></div>
      </div>
      <ul>
        <li v-for="(i,index) in listT" :key="index">
          <div class="name">{{i.name}}</div>
          <div class="desc">{{i.desc}}</div>
          <div class="info">{{i.info}}</div>
          <img :src="i.img">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gyl',
  data () {
    return {
      list: [{
        name: '全国一件代发业务支持',
        img: require('../../../assets/img/index/gylT1.png'),
        desc: '顺丰、京东、中通、韵达、邮政、跨越'
      }, {
        name: '全国多仓直发网络布局',
        img: require('../../../assets/img/index/gylT2.png'),
        desc: '多点布局    高效快捷'
      }, {
        name: '7*24小时客服快速响应',
        img: require('../../../assets/img/index/gylT3.png'),
        desc: '急您所需    尽我所能'
      }],
      listT: [{
        name: '系统API对接',
        img: require('../../../assets/img/index/gylTT1.png'),
        desc: '交付标准Api接口文档',
        info: '自动获取商品，回传订单'
      }, {
        name: '非API对接模式',
        img: require('../../../assets/img/index/gylTT2.png'),
        desc: '配置专属后台',
        info: '人工选品下载物料，订单回传'
      }]
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.gyl
  padding 0 px(20)
  margin-top px(60)
  .gylOne
    margin-top px(40)
    display flex
    justify-content space-between
    .jia
      height px(80)
      line-height px(80)
      font-size px(40)
      font-weight bold
      color #9a9a9a
    .left
      width px(458)
    .right
      width px(210)
    img
      width 100%
    .Otitle
      width 100%
      height px(80)
      line-height px(80)
      text-align center
      font-size px(26)
      background #1876AE
      color #FFFFFF
      margin-bottom px(20)
  .gylTwo
    margin-top px(58)
    li
      width 100%
      display flex
      margin-bottom px(20)
      img
        width px(260)
      .info
        display flex
        align-items center
        flex-flow row wrap
        margin-left px(26)
      .name
        width 100%
        font-size px(28)
        color #333333
      .desc
        width 100%
        font-size px(24)
        color #666666
  .gylThree
    .titleT
      color #666666
    ul
      display flex
      justify-content space-between
      margin-top px(40)
      li
        width px(345)
        // height px(180)
        box-shadow 0px 0px 16px 0px rgba(0, 0, 0, 0.14)
        border-radius px(10)
        position relative
        padding 0 px(20)
        img
          width px(100)
          position absolute
          top 0px
          right 0px
        .name
          margin-top px(26)
          font-size px(26)
        .desc
          font-size px(24)
        .info
          font-size px(20)
          color #666666
</style>



// WEBPACK FOOTER //
// src/pages/index/components/gyl.vue